module.exports = __webpack_public_path__ + "img/guide-suunto-1-android.b2ef18a4.jpg";